// Links to the dictionary. A headword page lives at /vocabulary/<encoded headword>; an entry written with a slash
// ("वि / पि", "अ / य") opens through its first word, because a slash cannot travel inside one path segment.

import type { DictPos } from '@/prakrit/lib/content/dictionary'

export const vocabHref = (word: string, surface?: string): string => {
    const target = word.includes('/') && surface ? surface : word

    return `/vocabulary/${encodeURIComponent(target.normalize('NFC'))}`
}

export const vocabListHref = (pos?: DictPos | null): string => (pos ? `/vocabulary?pos=${pos}` : '/vocabulary')
